import React from "react";
import { FirmAdmin } from "@cygnusaiinternal/cygnus-common";
import { FirmAdminProvider, useFirmAdminApi } from "../../context/FirmAdminContext";

const FirmAdminInner: React.FC = () => {
  const api = useFirmAdminApi();
  const firmName = localStorage.getItem("firmname") || "";
  const requestedBy = localStorage.getItem("username") || "";

  return (
    <FirmAdmin
      featureName="FRMADMN"
      firmName={firmName}
      requestedBy={requestedBy}
      api={api}
    />
  );
};

interface FirmAdminPageProps {
  transporter?: any;
}

const FirmAdminPage: React.FC<FirmAdminPageProps> = () => (
  <FirmAdminProvider>
    <FirmAdminInner />
  </FirmAdminProvider>
);

export default FirmAdminPage;
